// src/components/ProtectedRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../pages/Home1"; // Adjust path if necessary
import useInactivityTimer from "../hooks/useInactivityTimer"; // Import the hook
import { Spinner } from "react-bootstrap";

const ProtectedRoute = () => {
  // Get auth status and the logout function
  const { isLoggedIn, isLoading, logout } = useAuth();

  // --- Use the inactivity timer hook ---
  // Pass the logout function from the context as the callback
  // This will automatically call logout() after 15 minutes of inactivity
  // The hook only runs when ProtectedRoute is mounted (i.e., user is logged in accessing protected area)
  useInactivityTimer(logout);
  // ----------------------------------

  // Optional: Handle loading state during initial auth check
  if (isLoading) {
    return (
      <div
        className='d-flex justify-content-center align-items-center'
        style={{ minHeight: "80vh" }}
      >
        <Spinner animation='border' role='status' variant='primary'>
          <span className='visually-hidden'>Loading...</span>
        </Spinner>
      </div>
    );
  }

  // Check if logged in
  if (!isLoggedIn) {
    // If not logged in, redirect to the login page
    console.log("ProtectedRoute: User not logged in, redirecting to /login");
    return <Navigate to='/login' replace />;
  }

  // If logged in, render the child route component
  return <Outlet />;
};

export default ProtectedRoute;
